import { render } from "./RelationHeader.vue?vue&type=template&id=4b0cc1f3&scoped=true&ts=true"
import script from "./RelationHeader.vue?vue&type=script&lang=ts"
export * from "./RelationHeader.vue?vue&type=script&lang=ts"

import "./RelationHeader.vue?vue&type=style&index=0&id=4b0cc1f3&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0cc1f3"]])

export default __exports__